import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Form, Dropdown, Modal, Button } from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { apiHandler } from '../../../api/apihandler';
import { TEACHERS_CREATE_ACTIVITY_API, TEACHERS_RESULTS_LIST_DELETE_API, TEACHERS_RESULTS_LIST_PRINT_API, TEACHERS_RESULTS_LIST_UPDATE_API } from "../../../api/constants";
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import LessonPlanScreen from '../../../components/ai/LessonPlanScreen';
import AIResponseListCard from '../../../components/ai/AIResponseListCard';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Swal from 'sweetalert2';
import ActivityListCardByLessonPlan from '../../../components/ai/ActivityListCardByLessonPlan';

const TeachersHelperDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { data, gradeParam, classParam, isEdit } = location.state || {};
    const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
    const [apiResponseTextID, setApiResponseTextID] = useState(data?.lesson_plan?.id || '');
    const [apiResponseText, setApiResponseText] = useState(data?.lesson_plan?.result || '');
    const [editMode, setEditMode] = useState(isEdit || false);
    const [showActivityModal, setShowActivityModal] = useState(false);
    const [purpose, setPurpose] = useState(data?.purpose || '');
    const [topic, setTopic] = useState(data?.topic || '');
    const [specialInstruction, setSpecialInstruction] = useState('');
    const [activityListRefreshKey, setActivityListRefreshKey] = useState(0);

    // console.log("data", location.state);


    useEffect(() => {
    }, []);

    const handleEdit = () => {
        setEditMode(true);
    };
    const handleSaveEdit = (newText) => {
        getUpdateResponseApi(newText)
    };
    const handleDelete = () => {
        getDeleteResponseApi();
    };

    const handleActivitySubmit = (e) => {
        e.preventDefault();
        createActivityApi();
        setShowActivityModal(false);
    };

    async function getUpdateResponseApi(newText) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_RESULTS_LIST_UPDATE_API, "POST", {
                id: apiResponseTextID,
                result: newText,
            })
            if (res.data?.response?.status === 200) {
                setApiResponseText(newText);
                setEditMode(false);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getLessonplanPrintApi(apiResponseTextID) {
        try {
            const res = await apiHandler(TEACHERS_RESULTS_LIST_PRINT_API, "POST", {
                ai_search_result_id: apiResponseTextID,
            })
            if (res.data?.response?.status === 200) {
                window.open(res?.data?.data?.url, '_blank');
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function getDeleteResponseApi() {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_RESULTS_LIST_DELETE_API, "DELETE", {
                id: apiResponseTextID,
            })
            if (res.data?.response?.status === 200) {
                setApiResponseText('');
                setEditMode(false);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function createActivityApi() {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_CREATE_ACTIVITY_API, "POST", {
                aiSearchResultId: data?.lesson_plan?.id,
                gradeId: gradeParam?.grade_id,
                classId: classParam?.class_id,
                purpose: "Activity", //activityForm.purpose,
                topic: topic,
                specialInstruction: specialInstruction,
            })
            if (res.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success',
                    text: res?.data?.data?.message || 'Activity created successfully!',
                    icon: 'success',
                    confirmButtonText: 'Okay'
                })
                setActivityListRefreshKey(prev => prev + 1);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    return (
        <>
            <div id='content-page' className='content-page'>
                <Container>
                    <Row>
                        <Col lg={8}>
                            {
                                showMoreDataLoader ?
                                    <div className="col-sm-12 text-center">
                                        <img src={loader} alt="loader" style={{ height: "100px" }} />
                                    </div> :
                                    <Container className='relative'>
                                        <Row className="row-eq-height">
                                            <Col md="12">
                                                <Row>
                                                    <Col md="12">
                                                        <Card className="iq-border-radius-20">
                                                            <Card.Body>
                                                                <Row style={{ paddingLeft: "30px", paddingRight: "30px", marginTop: "20px" }}>
                                                                    <Col md="12" className="mb-3">
                                                                        <button
                                                                            className="btn btn-link p-0 me-2"
                                                                            onClick={() => navigate(-1)}
                                                                            style={{ fontSize: 20, verticalAlign: 'middle', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                                            aria-label="Back"
                                                                        >
                                                                            <span className="material-symbols-outlined" style={{ marginRight: 6 }}>arrow_back</span>
                                                                            <span style={{ fontSize: 18 }}>Back</span>
                                                                        </button>
                                                                        {/* <h3 className="card-title">Teachers Helper</h3>
                                                                        <p>Neque convallis a cras semper auctor. Libero id faucibus nisl tincidunt egetnvallis.</p> */}
                                                                    </Col>
                                                                </Row>
                                                                <Col md="12" style={{ paddingLeft: "30px", paddingRight: "30px" }}>
                                                                    <h3 className="card-title">
                                                                        {gradeParam?.grade_name ? gradeParam?.grade_name : null}
                                                                        {classParam?.class_name ? " | " + classParam?.class_name : null}
                                                                        {data?.purpose ? " | " + data?.purpose : null}
                                                                        {data?.topic ? " | " + data?.topic : null}</h3>
                                                                    {!editMode ? (
                                                                        <>
                                                                            <LessonPlanScreen lessonPlanText={apiResponseText} />
                                                                            <div className="send-btn pl-3 mb-2 d-flex justify-content-end">
                                                                                <button type="button" className="btn btn-warning me-2" onClick={handleEdit}>Edit</button>
                                                                                <button type="button" className="btn btn-primary me-2" onClick={() => getLessonplanPrintApi(data?.lesson_plan?.id)}>Print in PDF</button>
                                                                                <button type="button" className="btn btn-success me-2" onClick={() => setShowActivityModal(true)}>Add New Activity</button>
                                                                                <button type="button" className="btn btn-danger" onClick={handleDelete}>Delete</button>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <textarea
                                                                                className="form-control mb-2"
                                                                                rows={10}
                                                                                value={apiResponseText}
                                                                                onChange={e => setApiResponseText(e.target.value)}
                                                                            />
                                                                            {/* <ReactQuill
                                                                                theme="snow"
                                                                                value={apiResponseText}
                                                                                onChange={(value) => setApiResponseText(value)}
                                                                                modules={modules}
                                                                                placeholder="Edit your text here..."
                                                                            /> */}
                                                                            <div className="send-btn pl-3 mb-2 d-flex justify-content-end">
                                                                                <button type="button" className="btn btn-success me-2" onClick={() => handleSaveEdit(apiResponseText)}>Save</button>
                                                                                <button type="button" className="btn btn-secondary" onClick={() => setEditMode(false)}>Cancel</button>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </Col>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Container>
                            }
                        </Col>
                        <Col lg={4}>
                            {/* <AIResponseListCard /> */}
                            <ActivityListCardByLessonPlan refreshKey={activityListRefreshKey} aiSearchResultId={data?.lesson_plan?.id} />
                        </Col>
                    </Row>
                    <Modal show={showActivityModal} onHide={() => setShowActivityModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Add New Activity</Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={handleActivitySubmit}>
                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Grade</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="grade"
                                        value={gradeParam?.grade_name}
                                        // onChange={handleActivityInput}
                                        placeholder="Enter grade"
                                        required
                                        readOnly
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Class</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="class"
                                        value={classParam?.class_name}
                                        // onChange={handleActivityInput}
                                        placeholder="Enter class"
                                        required
                                        readOnly
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Purpose</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="purpose"
                                        value={"Activity"}
                                        // value={activityForm.purpose}
                                        // onChange={handleActivityInput}
                                        placeholder="Enter purpose"
                                        required
                                        readOnly
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Topics you want to cover:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="topic"
                                        value={topic}
                                        onChange={(e) => setTopic(e.target.value)}
                                        placeholder="Enter topic"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Special Instruction</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="Special Instruction"
                                        value={specialInstruction}
                                        onChange={(e) => setSpecialInstruction(e.target.value)}
                                        placeholder="Enter special instruction"
                                    // required
                                    />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowActivityModal(false)}>
                                    Cancel
                                </Button>
                                <Button variant="primary" type="submit">
                                    Save Activity
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                </Container>
            </div>
        </>
    )
}

export default TeachersHelperDetails